import { useCallback, useTransition } from 'react';
import useNotification from '@/hooks/useNotification';
import useTranslations from '@/hooks/useTranslations';

import unfavouriteCarpiProductConfiguration from '@/actions/productWorkflow/carpi/productConfiguration/unfavouriteCarpiProductConfiguration';
import useAuth from '@/lib/firebase/auth/store';
import { WorkflowCategories } from '@/types/fragments';

export default function useSmallUnfavourite({
  id,
  product,
}: {
  id: string;
  product: WorkflowCategories;
}) {
  const [, startUnfavouriting] = useTransition();
  const notifications = useNotification();
  const { t, locale } = useTranslations();
  const { userId } = useAuth();

  const handleUnfavouriting = useCallback(async () => {
    const onConfirm = async () => {
      startUnfavouriting(async () => {
        return unfavouriteCarpiProductConfiguration(id, locale, userId)
          .then(() => {
            notifications.success(t('product.workflow.unFavourite.success'));
          })
          .catch((error) => {
            console.log(error);
            notifications.error(t('product.workflow.unFavourite.error'));
          });
      });
    };

    return notifications.dialog({
      title: t('product.workflow.unFavourite.title'),
      message: t('product.workflow.unFavourite.message', { product }),
      severity: 'error',
      confirmText: t('product.workflow.unFavourite.confirmText'),
      onConfirm,
    });
  }, [notifications, t, id, locale, userId, product]);

  return { handleUnfavouriting };
}
